import { Ringpool} from "./class/Ringpool"
import { DelioLabels } from "./class/DelioLabels";
import { Globals } from "./globals/variables";


(async () => {

    const ringpool =new Ringpool();
    const delioLabels = new DelioLabels();
    delioLabels.loadLabels(); 
    globalThis.digitalData=delioLabels.getDigitalData()
    delioLabels.loadDelioLibs(Globals.DelioOneClick.init,Globals.idTagD1C);
    ringpool.getDefaultPhone(globalThis.digitalData)
    
})();